import React from 'react';

import './currentStyle.css';

const GetCurrentStyle = () => <React.Fragment></React.Fragment>;

export default GetCurrentStyle;
